import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ProductGate } from '@bloo-team/core-shell'

/**
 * Settings · Vantage — the product's tenant settings (today: Cases, the
 * case-management service). The subtree sits behind the Vantage entitlement
 * gate: the settings nav never lists it unentitled, and a deep link gets the
 * guard.
 */
function VantageSettingsLayout() {
  const { clusterId, scopeId } = Route.useParams()
  return (
    <ProductGate product="vantage" clusterId={clusterId} scopeId={scopeId}>
      <Outlet />
    </ProductGate>
  )
}

export const Route = createFileRoute('/$clusterId/$scopeId/settings/vantage')({
  component: VantageSettingsLayout,
})
